module.exports = __webpack_public_path__ + "static/media/livro-reclamacoes.4f4f1949.png";